import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {
    CustElemApiResponse,
    mapJsonToCustElemApiResponse,
    mapJsonToPrevCustElemApiResponse,
    mapJsonToPrevCustElemSumApiResponse,
    mapJsonToPrevServElemDTOSumApiResponse, mapJsonToPrevTesta,
    mapPrevCustElemToJson,
    PrevCustElem,
    PrevCustElemApiResponse,
    PrevCustElemSumApiResponse, PrevTesta
} from "./types";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {columnFiltersParam, sortingParam} from "./Services";
import * as Yup from "yup";


const moment = require('moment')


export function useCreatePrevCustElem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (prevcustelem: PrevCustElem) => {
      return AxiosInstance.post('prevcustelem/0/',mapPrevCustElemToJson(prevcustelem));
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fetchPrevCustElem'] }),
     });

}

export function useGetCustElem() {
  return useQuery<CustElemApiResponse>({
    queryKey: ['fetchGetCustElem'],
    queryFn: async () => {
      const response = await AxiosInstance.get('custelem/?limit=10000&offset=0');

      return mapJsonToCustElemApiResponse(response.data)
    },
    refetchOnWindowFocus: false,
  });
}


export function useGetPrevCustElemById(id: number) {
  return useQuery<PrevCustElemApiResponse>({
    queryKey: ['fetchGetPrevCustElemById', id],
    enabled: id > 0, // 🔑 THIS IS CRITICAL
    queryFn: async () => {
      const response = await AxiosInstance.get(
        `prevcustelem/?limit=1000&offset=0&PV07_ID=${id}`
      );

      const mapped = mapJsonToPrevCustElemApiResponse(response.data);

     // console.log('PREVCUSTELEM:', mapped);

      return mapped;
    },
    refetchOnWindowFocus: false,
  });
}

export const validationSchemaPrevCustElem: Yup.ObjectSchema<PrevCustElem> = Yup.object({
  id: Yup.string().required('Campo obbligatorio'),
  idprevtesta: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  desareacust: Yup.string().required('Campo obbligatorio'),
  codareacust: Yup.string().required('Campo obbligatorio'),
  desmodcust: Yup.string().required('Campo obbligatorio'),
  codmodcust: Yup.string().required('Campo obbligatorio'),
  numanalisi: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numconf: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numform: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numprep: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numtot: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  note: Yup.string().optional().nullable(),
  codnodoareacust: Yup.string().optional().nullable(),
  codnodomodcust: Yup.string().optional().nullable(),
  seqareacust: Yup.number().optional().nullable(),
  seqmodcust: Yup.number().optional().nullable(),
  flgprevcons: Yup.mixed<'P' | 'C' | 'F' >().oneOf(['P', 'C', 'F'], 'Valore non valido').required('Campo obbligatorio'),
});








export  function useGetPrevCustElemByPrev(pagination: MRT_PaginationState,columnFilters:  MRT_ColumnFiltersState,globalFilter: string,sorting: MRT_SortingState, idprevtesta: number) {
  return useQuery<PrevCustElemApiResponse>({
    queryKey: ['fetchPrevCustElem',
       columnFilters, //refetch when columnFilters changes
       globalFilter, //refetch when globalFilter changes
       pagination.pageIndex, //refetch when pagination.pageIndex changes
       pagination.pageSize, //refetch when pagination.pageSize changes
       sorting, //refetch when sorting changes
       idprevtesta
    ],
    queryFn: async () => {

      const myOffset = (pagination.pageIndex==0) ? "0": `${pagination.pageSize*(pagination.pageIndex)}`;
      // const myURL = '?limit='+`${pagination.pageSize}`+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      // const myURL = '?limit=1000'+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      const myURL = `?limit=1000&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParam(columnFilters,'PV07')}&ordering=${sortingParam(sorting,'PV07')}`;

      const response = await AxiosInstance.get(`prevcustelem/${myURL}&PV07_IDPREVTESTA_PV02=${idprevtesta}`);

      return mapJsonToPrevCustElemApiResponse(response.data)
    },
    refetchOnWindowFocus: false,
  });
}

export  function useGetPrevCustElemSumByPrev(pagination: MRT_PaginationState,columnFilters:  MRT_ColumnFiltersState,globalFilter: string,sorting: MRT_SortingState, idprevtesta: number) {
  return useQuery<PrevCustElemSumApiResponse>({
    queryKey: ['fetchPrevCustElemSum',
       columnFilters, //refetch when columnFilters changes
       globalFilter, //refetch when globalFilter changes
       pagination.pageIndex, //refetch when pagination.pageIndex changes
       pagination.pageSize, //refetch when pagination.pageSize changes
       sorting, //refetch when sorting changes
       idprevtesta
    ],
    queryFn: async () => {

      const myOffset = (pagination.pageIndex==0) ? "0": `${pagination.pageSize*(pagination.pageIndex)}`;
      // const myURL = '?limit='+`${pagination.pageSize}`+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      // const myURL = '?limit=1000'+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      const myURL = `?limit=1000&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParam(columnFilters,'PV07')}&ordering=${sortingParam(sorting,'PV07')}`;


      const response = await AxiosInstance.get('prevcustelemsumbyprev/'+idprevtesta+'/'+myURL);

      return mapJsonToPrevCustElemSumApiResponse(response.data)
    },
    refetchOnWindowFocus: false,
  });
}

export function useUpdatePrevCustElem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (prevcustelem: PrevCustElem) => {

         //console.log('CUSTELEMS:', prevcustelem)

         return AxiosInstance.patch('prevcustelem/'+prevcustelem.id+'/',mapPrevCustElemToJson(prevcustelem));


        // const requests = custelems.map(async (elem) => {
        //                 if (elem.id) {
        //                     console.log('ELEM:', elem);
        //                     await AxiosInstance.patch(`custelem/${elem.id}/`, mapCustElemToJson(elem));
        //                 }
        // });
     // await Promise.all(requests);
    },
     onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['fetchPrevCustElem'] });
            queryClient.invalidateQueries({ queryKey: ['fetchPrevCustElemSum'] });
          },
  });
}

export function useDeletePrevCustElem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
      const response = await AxiosInstance.delete('prevcustelem/'+id+'/');
     return  response
    },
     onSettled: () => queryClient.invalidateQueries({ queryKey: ['fetchPrevCustElem'] }), //refetch tipocontributo after mutation, disabled for demo
  });
}